// extracted by mini-css-extract-plugin
export default {"Focus":"Focus_Focus__9qr2y","spin":"Focus_spin__ucnh8"};